"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _objectSpread2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _importProduct = require("@/api/importProduct");
var _vuePropertyDecorator = require("vue-property-decorator");
var _importWarehouse = require("@/api/importWarehouse");
var ImportModal = /*#__PURE__*/function (_Vue) {
  function ImportModal() {
    var _this;
    (0, _classCallCheck2.default)(this, ImportModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, ImportModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "rules", {
      name: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "products", []);
    (0, _defineProperty2.default)(_this, "query", {
      limit: 30,
      page: 1
    });
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "productId", "");
    return _this;
  }
  (0, _inherits2.default)(ImportModal, _Vue);
  return (0, _createClass2.default)(ImportModal, [{
    key: "transformTable",
    get: function get() {
      var data = [];
      this.data.forEach(function (e) {
        // e.quantityRemain = e.quantityImport - e.quantityDelivery;
        data.push(e);
      });
      return data;
    }
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var data;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              this.loadingSubmit = true;
              data = {
                details: this.data.map(function (e) {
                  return (0, _objectSpread2.default)((0, _objectSpread2.default)({}, e), {}, {
                    productId: e.product.id
                  });
                })
              };
              _context.next = 5;
              return _importProduct.importProductApi.createImportWarehouse(this.form.id, data);
            case 5:
              this.$notify.success({
                title: "Thêm mới",
                message: "Successfully"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 8:
              _context.prev = 8;
              this.loadingSubmit = false;
              return _context.finish(8);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 8, 11]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              this.loadingSubmit = true;
              _context2.next = 4;
              return _importWarehouse.importWarehouseApi.update(this.form.id, {
                details: this.data
              });
            case 4:
              this.$notify({
                title: "Thông báo",
                message: "Thành công!",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 7:
              _context2.prev = 7;
              this.loadingSubmit = false;
              return _context2.finish(7);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0,, 7, 10]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate(data) {
      this.visible = true;
      this.status = "create";
      this.form = (0, _objectSpread2.default)({}, data);
      this.data = data.detailImports;
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)({}, data);
      this.visible = true;
      this.data = data.detailWarehouses;
      this.status = "update";
    }
  }]);
}(_vuePropertyDecorator.Vue);
ImportModal = (0, _tslib.__decorate)([_vuePropertyDecorator.Component], ImportModal);
var _default = exports.default = ImportModal;